import React from 'react'
import Courses from '../feature/Courses/Courses'

const CoursesPage = () => {
  return <Courses/>
}

export default CoursesPage